(() => {
    const FADE_MS = 220;

    /** Center the tab chip inside `.nw-mix-matcha-bundle__tabs ul` when the row overflows (mobile). */
    function scrollActiveTabIntoView(tabButton) {
      if (!(tabButton instanceof HTMLElement)) return;
      const list = tabButton.closest('.nw-mix-matcha-bundle__tabs ul');
      if (!list) return;
      if (list.scrollWidth <= list.clientWidth + 1) return;
      const li = tabButton.closest('li');
      const item = li || tabButton;
      const targetLeft =
        item.offsetLeft + item.offsetWidth / 2 - list.clientWidth / 2;
      const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      list.scrollTo({
        left: Math.max(0, Math.min(targetLeft, maxScroll)),
        behavior: 'smooth',
      });
    }

    function initBundleTabs(root) {
      const tabLinks = Array.from(root.querySelectorAll('.nw-mix-matcha-bundle__tabs [data-tab]'));
      const panels = Array.from(root.querySelectorAll('.nw-mix-matcha-bundle__products[data-tab-content]'));
      if (!tabLinks.length || !panels.length) return;

      const panelById = new Map(panels.map((p) => [p.getAttribute('data-tab-content'), p]));

      let activeId = tabLinks.find((el) => el.classList.contains('active'))?.dataset?.tab || tabLinks[0].dataset?.tab;
      if (!panelById.get(activeId)) activeId = tabLinks[0].dataset?.tab;

      function setActive(id) {
        if (!id || id === activeId) return;
        const nextPanel = panelById.get(id);
        if (!nextPanel) return;

        const prevPanel = panelById.get(activeId);

        tabLinks.forEach((el) => el.classList.toggle('active', el.dataset.tab === id));

        if (prevPanel) {
          prevPanel.classList.add('is-hiding');
          prevPanel.classList.remove('active');
          window.setTimeout(() => {
            prevPanel.classList.remove('is-hiding');
          }, FADE_MS);
        }

        nextPanel.classList.remove('is-hiding');
        nextPanel.classList.add('active');

        activeId = id;
        root.dispatchEvent(new CustomEvent('nw:tabchange', { detail: { id } }));
      }

      function setActiveFromClick(tabButton, id) {
        setActive(id);
        window.requestAnimationFrame(() => scrollActiveTabIntoView(tabButton));
      }

      // Sync initial state (in case markup/CSS differs).
      tabLinks.forEach((el) => el.classList.toggle('active', el.dataset.tab === activeId));
      panels.forEach((p) => {
        const isActive = p.getAttribute('data-tab-content') === activeId;
        p.classList.toggle('active', isActive);
        p.classList.remove('is-hiding');
      });

      const initialActiveBtn = tabLinks.find((el) => el.classList.contains('active'));
      if (initialActiveBtn) {
        window.requestAnimationFrame(() => scrollActiveTabIntoView(initialActiveBtn));
      }

      const onClick = (e) => {
        const el = e.currentTarget;
        if (!(el instanceof HTMLElement)) return;
        const tab = el.dataset?.tab;
        if (!tab) return;
        e.preventDefault();
        setActiveFromClick(el, tab);
      };

      tabLinks.forEach((el) => el.addEventListener('click', onClick));

      // Return teardown for Shopify customizer unloads.
      return () => {
        tabLinks.forEach((el) => el.removeEventListener('click', onClick));
      };
    }

    function mountWithin(container) {
      container.querySelectorAll('.nw-mix-matcha-bundle').forEach((root) => {
        if (root.__nwMixMatchaTabsDestroy) root.__nwMixMatchaTabsDestroy();
        root.__nwMixMatchaTabsDestroy = initBundleTabs(root) || null;
      });
    }

    function unmountWithin(container) {
      container.querySelectorAll('.nw-mix-matcha-bundle').forEach((root) => {
        if (root.__nwMixMatchaTabsDestroy) root.__nwMixMatchaTabsDestroy();
        root.__nwMixMatchaTabsDestroy = null;
      });
    }

    // Initial page load.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountWithin(document));
    } else {
      mountWithin(document);
    }

    // Shopify theme editor (customizer) lifecycle.
    document.addEventListener('shopify:section:load', (e) => {
      if (e && e.target) mountWithin(e.target);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      if (e && e.target) unmountWithin(e.target);
    });
    document.addEventListener('shopify:section:select', (e) => {
      if (e && e.target) mountWithin(e.target);
    });
    document.addEventListener('shopify:section:reorder', () => {
      mountWithin(document);
    });

    // If settings change re-renders markup, re-mount ensures handlers exist.
    document.addEventListener('shopify:section:refresh', (e) => {
      if (e && e.target) mountWithin(e.target);
    });
  })();